let localSeed = Date.now();

export const PRE_CHAT_FORM_TYPES = {
  CURRENT: 'current',
  STEPS: 'steps',
};

export const PRE_CHAT_FORM_ELEMENT_TYPES = [
  { value: 'information', label: 'Information' },
  { value: 'name', label: 'Name' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone number' },
  { value: 'choice_list', label: 'Choice list' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'multiple_choice', label: 'Multiple choice list' },
];

export const PRE_CHAT_STEP_FIELD_TYPES = PRE_CHAT_FORM_ELEMENT_TYPES;

export const normalizePreChatFormType = value =>
  value === PRE_CHAT_FORM_TYPES.STEPS
    ? PRE_CHAT_FORM_TYPES.STEPS
    : PRE_CHAT_FORM_TYPES.CURRENT;

export const generatePreChatId = prefix => {
  const nextSeed = localSeed;
  localSeed += 1;
  return `${prefix}_${nextSeed.toString(36)}`;
};

export const clonePreChatElement = element => ({
  ...element,
  choices: Array.isArray(element?.choices) ? [...element.choices] : [],
});

export const clonePreChatStep = step => ({
  ...step,
  elements: Array.isArray(step?.elements)
    ? step.elements.map(clonePreChatElement)
    : [],
});

export const isChoiceElement = type =>
  ['choice_list', 'dropdown', 'multiple_choice'].includes(type);

export const hasRenderablePreChatElements = elements =>
  Array.isArray(elements) && elements.some(element => element?.type);

export const hasRenderablePreChatSteps = steps =>
  Array.isArray(steps) &&
  steps.some(step => hasRenderablePreChatElements(step?.elements));

export const hasRenderablePreChatConfig = formConfig => {
  if (!formConfig || typeof formConfig !== 'object') return false;
  if (formConfig.enabled === false) return false;

  const formType = normalizePreChatFormType(formConfig.type);
  if (formType === PRE_CHAT_FORM_TYPES.STEPS) {
    return hasRenderablePreChatSteps(formConfig.steps);
  }

  return hasRenderablePreChatElements(formConfig.elements);
};

export const flattenPreChatElements = formConfig => {
  if (!formConfig || typeof formConfig !== 'object') return [];

  const formType = normalizePreChatFormType(formConfig.type);
  if (formType === PRE_CHAT_FORM_TYPES.STEPS) {
    return (formConfig.steps || []).flatMap(step =>
      Array.isArray(step?.elements) ? step.elements : []
    );
  }

  return Array.isArray(formConfig.elements) ? formConfig.elements : [];
};

export const createPreChatElement = type => {
  const base = { id: generatePreChatId('el'), type };

  if (type === 'information') {
    return {
      ...base,
      message: "Let's chat! Fill in a few details to get started.",
      collapsed: false,
    };
  }

  if (isChoiceElement(type)) {
    return {
      ...base,
      label: 'Question:',
      required: false,
      choices: ['Option 1', 'Option 2'],
      collapsed: false,
    };
  }

  const defaults = {
    name: 'Name:',
    email: 'E-mail:',
    phone: 'Phone number:',
    message: 'Message:',
    question: 'Question:',
    subject: 'Subject:',
  };

  return {
    ...base,
    label: defaults[type] || '',
    required: false,
    collapsed: false,
  };
};

export const createPreChatStep = ({
  title = 'Tell us more',
  description = '',
  elements = [createPreChatElement('name')],
} = {}) => ({
  id: generatePreChatId('step'),
  title,
  description,
  elements: elements.map(clonePreChatElement),
  collapsed: false,
});
